import { Box, IconButton, makeStyles, Typography } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@material-ui/lab";
import * as React from "react";
import { useState } from "react";
import { Create, required, SimpleForm, TextInput, useDataProvider, useNotify } from "react-admin";
import CreatedByField from "../../../../../Components/ReferenceFields/CreatedBy/CreatedByField";
import { RemarkTypes } from "../../../../../Enums/RemarkTypes";
import { useHistory } from "react-router-dom";
import RequestStatusField from "../../../../../Components/ReferenceFields/RequestStatus/RequestStatusField";
import { formatDate } from "../../../../../Helper/MomentHelper";

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: 40,
  },
  title: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "1em",
  },
  form: {
    [theme.breakpoints.up("xs")]: {
      width: 400,
    },
    [theme.breakpoints.down("xs")]: {
      width: "100vw",
      marginTop: -30,
    },
  },
  inlineField: {
    display: "inline-block",
    width: "50%",
  },
  ul: {
    listStyleType: "none",
  },
  warningBox: {
    backgroundColor: "#FEF3C7",
    border: "1px solid #F59E0B",
    borderRadius: 4,
    padding: 12,
    margin: "0 16px 16px 16px",
  },
  warningText: {
    color: "#92400E",
    fontSize: 14,
  },
}));

const NotesTimeLine = ({ requestId, remarkType }) => {
  const provider = useDataProvider();
  const [noteData, setNoteData] = useState<any>([] as any);
  const getNoteData = async () => {
    const { data } = await provider.getList("pbhrequestremarks", {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "id", order: "DESC" },
      filter: { remarkType__eq: remarkType, requestId__eq: requestId },
    });

    if (data !== null && data !== undefined && data.length > 0) {
      let mappedData = data.map(item => ({
        remark: item.remark,
        createdBy: item.createdBy,
        createdDate: formatDate(item.createdDate),
        requestStatus: item?.statusCode,
      }));
      setNoteData(mappedData);
    }
  };
  //For Build
  React.useEffect(() => {
    getNoteData();
  }, [requestId]);

  return (
    <Timeline align="left">
      {noteData.map((item, key) => (
        <TimelineItem key={key}>
          <TimelineOppositeContent>
            <Typography color="textSecondary">{item.createdDate}</Typography>
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot variant="outlined" color="primary" />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            {item.remark.match(/.{1,20}/g).map(element => {
              return <li title={element}>{element}</li>;
            })}
          </TimelineContent>
          <TimelineContent>
            <ul>
              <li>
                <strong>
                  <CreatedByField record={item} />
                </strong>
              </li>
              <li>
                <strong>
                  <RequestStatusField record={item} reference="pbhrequeststatusinfo/reference" />
                </strong>
              </li>
            </ul>
          </TimelineContent>
        </TimelineItem>
      ))}
    </Timeline>
  );
};

const PbhRequestOrderNotes = ({ onCancel, request, remarkType, title = "Create", ...props }) => {
  const classes = useStyles();
  const [value, setValue] = useState();
  const notify = useNotify();

  var history = useHistory();
  const onRedirect = () => {
    onCancel?.(value);
    notify(`Pbh Request Note Successfully Added`, "success", false, true);
    return history.location.pathname;
  };
  const onChange = e => {
    setValue(e.target.value);
  };
  return (
    <div className={classes.root}>
      <div className={classes.title}>
        <Typography variant="h6">{title}</Typography>
        <IconButton onClick={onCancel}>
          <CloseIcon />
        </IconButton>
      </div>
      {request?.advancedXo && (
        <Box className={classes.warningBox}>
          <Typography className={classes.warningText}>
            <strong>Dikkat!</strong> Bu istek için <strong>{request.advancedXo}</strong> Advanced XO mevcuttur. Lütfen
            faal gönderim için bunu kullanın.
          </Typography>
        </Box>
      )}
      <Create title={" "} {...props} onSuccess={props?.onSuccess}>
        <SimpleForm redirect={onRedirect}>
          <TextInput
            source="requestId"
            label="Request"
            initialValue={request.id}
            validate={required()}
            disabled
            fullWidth
            rows={3}
            variant="outlined"
          />
          <TextInput
            source="statusCode"
            label="Request Status"
            initialValue={request.requestStatus}
            validate={required()}
            disabled
            fullWidth
            variant="outlined"
          />
          <TextInput
            source="remark"
            label="Remark"
            validate={required()}
            multiline
            resettable
            fullWidth
            rows={3}
            variant="outlined"
            onChange={onChange}
          />
          <TextInput
            source="remarkTypeCode"
            label="Remark Type Code"
            initialValue={RemarkTypes[remarkType]}
            validate={required()}
            disabled
            fullWidth
            variant="outlined"
          />
          <TextInput
            source="remarkType"
            label="Remark Type"
            initialValue={remarkType}
            validate={required()}
            disabled
            fullWidth
            variant="outlined"
          />
        </SimpleForm>
      </Create>
      <NotesTimeLine requestId={request.id} remarkType={remarkType} />
    </div>
  );
};
export default PbhRequestOrderNotes;
